import { executeGraphqlRequest } from 'apollo/graphql-request';

export type SubscriptionPlanKey = 'free' | 'pro';
export type SubscriptionEntitlementKey =
  | 'advanced_analytics'
  | 'max_published_positions'
  | 'priority_matching';

export interface SubscriptionPlanSummary {
  key: SubscriptionPlanKey;
  name: string;
  rank: number;
}

export interface SubscriptionEntitlementSummary {
  key: SubscriptionEntitlementKey;
  booleanValue?: boolean | null;
  integerValue?: number | null;
  source: string;
}

export interface SubscriptionOverview {
  plan: SubscriptionPlanSummary;
  subscription?: {
    provider?: 'INTERNAL' | 'STRIPE' | 'APP_STORE' | 'PLAY_STORE';
    status: string;
    cancelAtPeriodEnd: boolean;
    currentPeriodEndsAt?: string | null;
    trialEndsAt?: string | null;
  } | null;
  entitlements: SubscriptionEntitlementSummary[];
}

interface MySubscriptionQueryResponse {
  mySubscription: SubscriptionOverview;
}

const MY_SUBSCRIPTION_QUERY = `
  query MySubscription {
    mySubscription {
      plan {
        key
        name
        rank
      }
      subscription {
        provider
        status
        cancelAtPeriodEnd
        currentPeriodEndsAt
        trialEndsAt
      }
      entitlements {
        key
        booleanValue
        integerValue
        source
      }
    }
  }
`;

export async function fetchMySubscription(
  accessToken?: string
): Promise<SubscriptionOverview> {
  const data = await executeGraphqlRequest<MySubscriptionQueryResponse>(
    MY_SUBSCRIPTION_QUERY,
    {},
    {
      accessToken,
      requestName: 'MySubscription',
    }
  );

  return data.mySubscription;
}
